import styled from "styled-components";
import { BULKBAR_TOP_OFFSET_CSS_VARIABLE } from "./Bulkbar.constants.js";
import { BulkbarProps } from "./Bulkbar.types.js";

const topOffset = `var(${BULKBAR_TOP_OFFSET_CSS_VARIABLE}, 0px)`;

export const StyledBulkbar = styled.div<Omit<BulkbarProps, "selectedCount" | "onClose">>`
    display: flex;
    gap: ${(props) => `${props.theme.spacing[32]}`};
    align-items: center;
    transform: translate(-50%, calc(-120% - ${topOffset}));
    position: fixed;
    top: ${topOffset};
    left: 50%;
    margin-right: 5vw;
    z-index: ${({ theme }) => theme.elevationLevels.four};
    background: ${({ theme }) => theme.grayscale.white};
    box-shadow: ${(props) => props.theme.shadows.popover};
    border-radius: ${(props) => props.theme.radius.xs};
    padding: ${(props) => `${props.theme.spacing[16]}`} ${(props) => `${props.theme.spacing[24]}`};
    /* max-content rather than fit-content: with left: 50% the available width is only half the viewport. */
    width: max-content;
    max-width: calc(100vw - 2 * ${(props) => props.theme.spacing[16]});
    transition: all 170ms;
    &.show {
        transform: translate(-50%, 0%);
        transition: all 150ms;
    }

    & > div:first-child {
        display: flex;
        align-items: center;
        gap: ${(props) => `${props.theme.spacing[8]}`};

        & > div {
            /* margin-left: ${(props) => `${props.theme.spacing[16]}`}; */
            white-space: nowrap;
        }
    }
`;

export const SelectedCountWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${(props) => `${props.theme.spacing[8]}`};
`;

export const StyledChildrenWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    min-width: 0;
    align-items: center;
    gap: ${(props) => `${props.theme.spacing[16]}`};
`;
